module.exports = __webpack_public_path__ + "img/打印机.d491999e.png";